// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AHId","option":"styles_option__1xl64","selected":"styles_selected__K5mjm"};